import React from 'react'
import { Select } from '@arnsbogroup/react-voicearchive'

export const CharacterSelect = ({value = null, onChange = () => {}, placeholder = null, options = []}) => {
    return (
        <Select
            menuPortalTarget={document.body} // Renders the dropdown at the root level to avoid parent container overflow-hidden
            styles={{
                container: (provided) => ({
                    ...provided,
                    width: 'max-content',
                }),
                control: (base, state) => ({
                    ...base,
                    backgroundColor: 'var(--color-primary)',
                    color: '#FFFFFF',
                    border: '2px solid var(--color-primary)',
                    borderRadius: '0.125rem',
                    padding: '0.25rem 0.75rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    minHeight: 'auto',
                    '&:hover': {
                    backgroundColor: '#FFFFFF',
                    color: 'var(--color-primary)',
                    },
                    padding: '5px'
                }),
                placeholder: (base) => ({
                    ...base,
                    color: '#FFFFFF',
                    '&:hover': {
                    color: 'var(--color-primary)',
                    },
                }),
                valueContainer: (base) => ({
                    ...base,
                    padding: '0',
                }),
            }}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            options={options}
        />
    )
}

export default CharacterSelect
